import React, { useEffect, useState } from "react";
import { BRAND_COLOR } from "../../../common/constants";
import { fetchAllFaqs } from "./faqService";
import "./faqs.css";

const Faqs = () => {

 const [faqs, setFaqs] = useState([]);
 const [activeIndex, setActiveIndex] = useState(null);
 const [loading, setLoading] = useState(false);

 useEffect(() => {
 loadFaqs();
 }, []);

 const loadFaqs = async () => {

 setLoading(true);

 const response = await fetchAllFaqs();

 if (response.status === 200) {
 setFaqs(response.data || []);
 }

 setLoading(false);

 };

 const toggleFAQ = (index) => {
 setActiveIndex(activeIndex === index ? null : index);
 };

 return (

 <div className="faqs-page">

 <h1
 className="faqs-title"
 style={{ color: BRAND_COLOR }}
 >
 Frequently Asked Questions
 </h1>

 <p className="faqs-subtitle">
 Find answers to common questions about Speak Bold with KK.
 </p>

 {loading ? (

 <p className="faqs-loading">
 Loading FAQs...
 </p>

 ) : faqs.length === 0 ? (

 <p className="faqs-empty">
 No FAQs available right now.
 </p>

 ) : (

 faqs.map((faq, index) => (

 <div
 key={faq.id || index}
 className="faq-item"
 >

 <div
 onClick={() => toggleFAQ(index)}
 className={`faq-question ${
 activeIndex === index ? "active" : ""
 }`}
 >
 <span>{faq.question}</span>
 <span className="faq-icon">
 {activeIndex === index ? "−" : "+"}
 </span>
 </div>

 {activeIndex === index && (

 <div className="faq-answer">

 <div className="faq-answer-text">
 {faq.answer}
 </div>

 {faq.youtubeVideoLink && faq.youtubeVideoLink.trim() !== "" && (
 <div className="faq-video-link-wrapper">
 <a
 href={faq.youtubeVideoLink}
 target="_blank"
 rel="noreferrer"
 className="faq-video-link"
 >
 Watch related video
 </a>
 </div>
 )}

 </div>

 )}

 </div>

 ))

 )}

 </div>

 );

};

export default Faqs;